import {Col, Layout, Row} from "antd";
import HeaderLayout from "../headerLayout/HeaderLayout";
import MenuLayout from "../menuLayout/MenuLayout";
import FooterLayout from "../footerLayout/FooterLayout";
import TabLayout from '../tabLayout/TabLayout'
import React, { useState, useEffect } from "react";
import './ContainerLayout.less'
import {findContent} from "util";
import {initWXinConfig} from "../../util/WXinShare";

const {
    Header, Footer, Content,
} = Layout;

function ContainerLayout(props) {
    const [isMobileDevice, setIsMobileDevice] = useState(false);
    const [name, setName] = useState('');
    const [data, setData] = useState({});

    useEffect(() => {
        if (document.body.clientWidth <= 750) {
            setIsMobileDevice(true)
        }
        setName(location.pathname.match(/^\/[^\/]*/g)[0].substr(1))
        findContent('menu.json').then(res => {
            setData(res)
        })
    }, []);

    useEffect(() => {
        initWXinConfig()
    }, [location.pathname])

    return <div className="container_layout">
        <Layout>
            <Header>
                <HeaderLayout {...props}/>
            </Header>
            <Content className={'container_content container_' + name + '_content'}>
                {
                    data.tabs &&
                    !isMobileDevice &&
                    <Row className="container_menu_row" type={"flex"}
                         justify={"center"}>
                        <Col>
                            <MenuLayout {...props} tabList={data.tabs}
                                        mode={isMobileDevice ? 'inline' : 'horizontal'}/>
                        </Col>
                    </Row>
                }
                {
                    data.tabs &&
                    isMobileDevice &&
                    <Row className="container_tab_row" type={"flex"}
                         justify={"start"}>
                        <Col>
                            <TabLayout {...props} tabList={data.tabs}/>
                        </Col>
                    </Row>
                }
                <div className={'container_subject_layout container_' + name + '_layout'}>
                    {
                        props.children
                    }
                </div>
            </Content>
            <Footer>
                <FooterLayout/>
            </Footer>
        </Layout>
    </div>
}

export default ContainerLayout
